
import { BrowserModule } from '@angular/platform-browser';
 import { RecaptchaModule } from "ng-recaptcha";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Provider } from '@angular/core';
 
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
 
import {ReactiveFormsModule} from "@angular/forms";
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { WatchersEnterQRkeyComponent } from './watchers-enter-qrkey/watchers-enter-qrkey.component';	 
//

import {WatchersExceededLimitComponent} from './channels/pages/watchers-exceeded-limit/watchers-exceeded-limit.component'

import {LoginPageComponent} from './login-page/login-page.component';
import {ProfilePageComponent} from "./profile-page/profile-page.component"; 
import {SiteLayoutComponent} from './shared/layouts/site-layout/site-layout.component';
import {AuthLayoutComponent} from './shared/layouts/auth-layout/auth-layout.component';
import {WatchersLayoutComponent} from './shared/layouts/watchers-layout/watchers-layout.component';
import {WatchersPageComponent} from './watchers-page/watchers-page.component';
import {WatchersEmbedPageComponent} from './watchers-embed-page/watchers-embed-page.component';

import {WatchEmbedComponent} from './watchers-embed-page/watch/watch-embed.component';
import {AccessEmbedComponent} from './watchers-embed-page/access/access-embed.component';


import {WatchComponent} from './watchers-page/watch/watch.component';
import {AccessComponent} from './watchers-page/access/access.component';
import {OverviewVideoPageComponent} from './overview-video-page/overview-video-page.component';

 
import {StatisticsPageComponent} from './statistics-page/statistics-page.component';
import {IncomePageComponent} from './income-page/income-page.component';
import {IncomeInnerPageComponent} from './income-page/income-inner-page/income-inner-page.component';
import {StatisticsInnerPageComponent} from './statistics-page/statistics-inner-page/statistics-inner-page.component';
import {StatModalKeysComponent} from './shared/components/stat-modal-keys/stat-modal-keys.component';


import  {PublicStatPageComponent} from './public-stat-page/public-stat-page.component';
import  {PartnerStatPageComponent} from './partner-stat-page/partner-stat-page.component';

import {ChannelsLayoutComponent} from './shared/layouts/channels-layout/channels-layout.component';


//
import {RegisterPageComponent} from './register-page/register-page.component';
import {ResetPasswordPageComponent} from './reset-password-page/reset-password-page.component';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClient} from "@angular/common/http";
import {TokenInterceptor} from "./shared/classes/token-interceptor";
import {WatchTokenService} from "./shared/services/watch-token.service";
//
import {OverviewPageComponent} from './overview-page/overview-page.component';
import {OverviewRestreamsPageComponent} from './overview-restreams-page/overview-restreams-page.component';
import {OverviewPlaylistPageComponent} from './overview-playlist-page/overview-playlist-page.component';
import {ChannelsModule} from './channels/channels.module';

import {StreamPageComponent} from './stream-page/stream-page.component';
import {StreamDownloadComponent} from './stream-page/stream-download/stream-download.component';
import {StreamMoveFromVideoComponent} from './stream-page/stream-move-from-video/stream-move-from-video.component';
import {StreamRestreamsModalComponent} from './stream-page/restreams-modal/restreams-modal.component';

import {VideoPageComponent} from './video-page/video-page.component';
import {VideoOverviewComponent} from './video-page/video-overview/video-overview.component';
import {StreamOverviewComponent} from './stream-page/stream-overview/stream-overview.component';

import {PlaylistPageComponent} from './playlist-page/playlist-page.component';

import {ModalUploadVideoComponent} from './video-page/modals/modal-upload-video/modal-upload-video.component';
/**/
import {StreamSettingsComponent} from './shared/components/stream-settings/stream-settings.component';
import {StreamSettingsCommonComponent} from './shared/components/stream-settings/stream-settings-common/stream-settings-common.component';
import {StreamSettingsAccessComponent} from './shared/components/stream-settings/stream-settings-access/stream-settings-access.component';
import {StreamSettingsRestreamsComponent} from './shared/components/stream-settings/stream-settings-restreams/stream-settings-restreams.component';
import {StreamSettingsProtectionComponent} from './shared/components/stream-settings/stream-settings-protection/stream-settings-protection.component';


import {StreamInfoComponent} from './shared/components/stream-settings/stream-info/stream-info.component';
import {StreamCountdownComponent} from './shared/components/stream-settings/stream-countdown/stream-countdown.component';


import {PlaylistInfoComponent} from './shared/components/playlist-info/playlist-info.component';
import {SubtitlesControlComponent} from './shared/components/subtitles-control/subtitles-control.component';
import {StreamKeysControlComponent} from './shared/components/stream-keys-control/stream-keys-control.component';
import {StreamSaleControlComponent} from './shared/components/stream-sale-control/stream-sale-control.component';
import {PlaylistSaleControlComponent} from './shared/components/playlist-sale-control/playlist-sale-control.component';
import {StreamDonateControlComponent} from './shared/components/stream-donate-control/stream-donate-control.component';
import {StreamQrToggleControlComponent} from './shared/components/stream-qr-toggle-control/stream-qr-toggle-control.component';
import {StreamUnlockFormSettingControlComponent} from './shared/components/stream-unlock-form-setting-control/stream-unlock-form-setting-control.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'


import {VideoPlayerComponent} from './shared/components/video-player/video-player.component';
import {RestreamPlayerComponent} from './shared/components/restream-player/restream-player.component';
import {VideoPlayerPreviewComponent} from './shared/components/video-player-preview/video-player-preview.component';

import {WatchVideoPlayerComponent} from './shared/components/watch-video-player/watch-video-player.component';

import {LOCALE_ID} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
registerLocaleData(localeRu, 'ru-RU', localeRuExtra);

//watch-video-player 
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { 
  SocketStreamsControl, 
  SocketCdnControl, 
  SocketStreamsChat,  
  SocketRestreamsOverview, 
  SocketStreamsOverview, 
  SocketStreamsWatch,
SocketVideosOverview,
 SocketIncome,
SocketQrEnterWatch,
SocketVideosControl } from './shared/services/sockets'
  import {ChannelEditPageComponent} from "./channel-edit-page/channel-edit-page.component";

import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NbMomentDateModule} from '@nebular/moment';
import {NbDateFnsDateModule} from '@nebular/date-fns';
import { ru } from 'date-fns/locale';
  
const TOKEN_INTERCEPTOR: Provider = {
  provide: HTTP_INTERCEPTORS,
  multi: true,
  useClass: TokenInterceptor
}

const maskConfig: Partial<IConfig> = {
  validation: false,
};

import {AlertsComponent} from './shared/components/alerts/alerts.component';

import {

  NbChatModule,
  NbDatepickerModule,
  //  NbTimepickerModule,
  NbToggleModule,
  NbDialogModule,
  NbMenuModule,
NbListModule,
  NbTabsetModule,
  NbSidebarModule, 
	
  NbToastrModule,
  NbWindowModule,

  NbCheckboxModule,

//NbButtonModule
} from '@nebular/theme';
import { StreamerChatComponent } from './shared/components/chats/streamer-chat/streamer-chat.component';
import { ChatBlacklistModalComponent } from './shared/components/chats/streamer-chat/chat-blacklist-modal/chat-blacklist-modal.component';

import { WatcherChatComponent } from './shared/components/chats/watcher-chat/watcher-chat.component';
import { WatcherChatEloginComponent } from './shared/components/chats/watcher-chat/login-email/watcher-chat-elogin.component';
import { OverviewRestreamsItemComponent } from './overview-restreams-page/overview-restreams-item/overview-restreams-item.component';
import { SrtPointModalComponent } from './overview-restreams-page/srt-point-modal/srt-point-modal.component';
import { OverviewRestreamsInfoComponent } from './overview-restreams-page/overview-restreams-info/overview-restreams-info.component';
 //import {ChannelsHeaderComponent} from './channels/components/header/channels-header.component'
import {SharedModule} from './shared/shared.module';
//import { CommonModule } from '@angular/common';
import {ChatEmbedPageComponent} from './chat-embed-page/chat-embed-page.component';
import {AdminGuard} from "./shared/classes/admin.guard";
import {ExpensesPageComponent} from './expenses-page/expenses-page.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import {PaymentModalComponent} from './shared/components/payment-modal/payment-modal.component';
import {BuyTariffModalComponent}  from './shared/components/buy-tariff-modal/buy-tariff-modal.component';

//import {ScriptsService} from './shared/services/scripts.service';
//import {SortablejsModule} from 'angular-sortablejs';

import { SortablejsModule } from 'ngx-sortablejs';
 import {SkeletonOverviewsComponent} from './shared/components/skeleton-overviews/skeleton-overviews.component';
 import {SkeletonPageComponent} from './shared/components/skeleton-page/skeleton-page.component';
 
 
 import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
 
 import {TranslateHttpLoader} from '@ngx-translate/http-loader';

 const createTranslateLoader = (http: HttpClient) =>{ 
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');

}


@NgModule({
  declarations: [
WatchersEnterQRkeyComponent,
SkeletonOverviewsComponent,
SkeletonPageComponent,
AppComponent,
      LoginPageComponent, 
      AuthLayoutComponent,
      SiteLayoutComponent, 
      OverviewPageComponent,
      ChannelsLayoutComponent,
      RegisterPageComponent,
       //CdnControlComponent,
      StreamPageComponent,
     StreamRestreamsModalComponent,
PageNotFoundComponent,
      OverviewRestreamsPageComponent,
PlaylistPageComponent,
OverviewPlaylistPageComponent,
      StreamOverviewComponent,
      StreamSettingsComponent,
      StreamSettingsCommonComponent,
      StreamSettingsAccessComponent,
      StreamSettingsProtectionComponent,
      StreamSettingsRestreamsComponent,
      StreamInfoComponent,
      StreamCountdownComponent,
PlaylistInfoComponent,
      VideoPlayerComponent,
      RestreamPlayerComponent,
      WatchersLayoutComponent,
      WatchersPageComponent,
      WatchVideoPlayerComponent,
      WatchComponent,
      AccessComponent,
      StreamerChatComponent,
	ChatBlacklistModalComponent,
      WatchersEmbedPageComponent,
	WatchEmbedComponent,
	 AccessEmbedComponent,
      WatcherChatComponent,
      WatcherChatEloginComponent,
      OverviewRestreamsItemComponent,
      SrtPointModalComponent,
      OverviewRestreamsInfoComponent,
      ChannelEditPageComponent,
       ChatEmbedPageComponent,
	ProfilePageComponent,
   ResetPasswordPageComponent,

   OverviewVideoPageComponent,
StatisticsPageComponent,
StatisticsInnerPageComponent,
StatModalKeysComponent,
IncomePageComponent,
IncomeInnerPageComponent,
VideoOverviewComponent,
VideoPageComponent,
   ModalUploadVideoComponent,
VideoPlayerPreviewComponent,
StreamKeysControlComponent,
StreamSaleControlComponent,
PlaylistSaleControlComponent,
StreamDonateControlComponent,
StreamUnlockFormSettingControlComponent,
StreamQrToggleControlComponent,
PublicStatPageComponent,
PartnerStatPageComponent,
StreamDownloadComponent,
StreamMoveFromVideoComponent,
ExpensesPageComponent,
AlertsComponent,
PaymentModalComponent,
BuyTariffModalComponent,
WatchersExceededLimitComponent,
SubtitlesControlComponent
],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    TranslateModule.forRoot({
      
   
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
    
      }
    }),
    

    AppRoutingModule,
    SharedModule,
    NbSidebarModule.forRoot(),
 SortablejsModule.forRoot({ animation: 150}),
    NgxMaskModule.forRoot(maskConfig),
    NbDatepickerModule.forRoot(),
  QRCodeModule,
 NbListModule,
     NbDialogModule.forRoot(),
    NbTabsetModule,
  //NbButtonModule,

  //  NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule,
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  
    NbMomentDateModule,
    NbDateFnsDateModule.forRoot({
      format: 'dd.MM.yyyy', 
      parseOptions: { 
        locale: ru 
      },
      formatOptions: { 
        locale: ru,
        
      }
  }),
   
    SocketIoModule,
 
   // NgbAlertModule,
   // NgbToastModule,
    NgbModule,
      RecaptchaModule,
    ChannelsModule
  ],
  providers: [
 /*  */  SocketStreamsControl,
    SocketStreamsWatch,
    SocketStreamsOverview,
    SocketStreamsChat,
    SocketCdnControl,
    SocketRestreamsOverview,
    SocketQrEnterWatch,
SocketIncome,
//ScriptsService,
SocketVideosOverview,
SocketVideosControl,
    WatchTokenService,
    TOKEN_INTERCEPTOR,
{provide: LOCALE_ID, useValue: 'ru-RU'},
  AdminGuard

  ],
  bootstrap: [
    AppComponent
  ],

  entryComponents:[
  //  StreamSettingsComponent
  ]

})
export class AppModule {
}
